const DB_NAME = 'userwallet';
const DB_VERSION = 1;
const STORE_NAME = 'kv';

let dbInstance: IDBDatabase | null = null;

function openDb(): Promise<IDBDatabase> {
  if (dbInstance !== null) {
    return Promise.resolve(dbInstance);
  }
  return new Promise<IDBDatabase>((resolve, reject): void => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = (): void => {
      reject(req.error);
    };
    req.onsuccess = (): void => {
      dbInstance = req.result;
      resolve(req.result);
    };
    req.onupgradeneeded = (): void => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'key' });
      }
    };
  });
}

/**
 * Get value by key. Returns null if not found.
 */
export async function idbGet(key: string): Promise<string | null> {
  const db = await openDb();
  return new Promise<string | null>((resolve, reject): void => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const req = store.get(key);
    req.onerror = (): void => {
      reject(req.error);
    };
    req.onsuccess = (): void => {
      const row = req.result as { key: string; value: string } | undefined;
      resolve(row?.value ?? null);
    };
  });
}

/**
 * Set value by key.
 */
export async function idbSet(key: string, value: string): Promise<void> {
  const db = await openDb();
  return new Promise<void>((resolve, reject): void => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const req = store.put({ key, value });
    req.onerror = (): void => {
      reject(req.error);
    };
    req.onsuccess = (): void => {
      resolve();
    };
  });
}

/**
 * Remove value by key.
 */
export async function idbRemove(key: string): Promise<void> {
  const db = await openDb();
  return new Promise<void>((resolve, reject): void => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    const req = store.delete(key);
    req.onerror = (): void => {
      reject(req.error);
    };
    req.onsuccess = (): void => {
      resolve();
    };
  });
}
